import { getRequiredElement } from "../Utilities/attributes";

export const initializeCopyFields = () => {
  const copyFields = document.querySelectorAll<HTMLElement>("[data-copy-field]");

  copyFields.forEach(copyField => {
    const copyButton = getRequiredElement<HTMLElement>(
      copyField,
      "button",
      "Copy button not found."
    );

    copyButton.addEventListener("click", async (event: Event) => {
      const targetNode = event.target as Element;
      const button = targetNode.closest("button") as HTMLElement;
      const input = button.previousElementSibling as HTMLInputElement;

      if (input) {
        // Copy the text inside the text field
        await navigator.clipboard.writeText(input.value);

        button.dataset.copied = "true";

        setTimeout(() => {
          button.dataset.copied = "false";
        }, 1000);
      }
    });
  });
};

initializeCopyFields();
